import { API, graphqlOperation } from 'aws-amplify';

export const onSubscribe = (query, key, onSuccessData, onError) => {
  return API.graphql(graphqlOperation(query)).subscribe({
    next: ({ value }) => {
      const data = value?.data?.[key];
      if (data) {
        onSuccessData(data);
      } else {
        console.warn(`onSubscribe: Invalid data received for key ${key}`, value);
      }
    },
    error: error => {
      console.warn(error);
      onError && onError(error);
    },
  });
};
